import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/health/')({
	ssr: true,
	component: () => <div>ok</div>
})
